import { styled, Typography } from '@mui/material';

export const AddFileButtonWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	padding: '5px 9px',
	gap: '8px',
	borderRadius: '8px',
	background: 'rgba(255, 255, 255, 0.7)',
	cursor: 'pointer',
	transition: 'all .3s',

	'&:hover': {
		background: '#FFF',
	},
});

export const AddFileButtonTitle = styled(Typography)(({ theme }) => ({
	color: theme.palette.primary.main,
}));
